export enum DeviceType {
  SMART_MANHOLE = 'smart_manhole',
  SMART_ALARM = 'smart_alarm',
  SMART_CAP = 'smart_cap',
  GROUND_WATER = 'water_ground_meter',
  HYDRANT = 'hydrant',
  WATER_FLOW = 'water_flow',
  MANNINGS_PAIR = 'mannings_pair',
}
